enum OcurrenceGeneralStatus {
    Registered = 1,
    UnderAnalysis = 2,
    Completed = 3
}

export default OcurrenceGeneralStatus;